import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CardSetTransformationService, DataService, DialogResult, DialogService, SaveDataRequest, SaveFormEvent, SpinnerService } from 'dspx-core';
import { finalize, take } from 'rxjs';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from 'src/app/constants/api-endpoints.constants';
import { POP_UP_CODES, SAVE_RESULT_STATUS } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { BankDetailCreateUpdateType } from 'src/app/enum/bank-detail-create-update-type.enum';
import { PersonBankDetailResponse } from 'src/app/interfaces/person-bank-detail-response.interface';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-detail.component.html',
  styleUrl: './bank-detail.component.scss'
})
export class BankDetailsComponent extends BaseCardSetDetailComponent implements OnInit {
  constructor(private route: ActivatedRoute,
    protected router: Router,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private spinnerService: SpinnerService,
    private dataService: DataService,
    private errorService: ErrorService,) {
    super(router, appDataService, dialogService);
  }
  fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;
  templateId: number = TEMPLATES.bankDetail;
  versionNo: number = VERSIONS.latest;
  id: string = '';
  activeDialog: string = '';
  personId: string;
  bankDetailCreateUpdateType;
  saveFormEvent: SaveFormEvent;

  ngOnInit(): void {
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      this.personId = paramMap.get('personId');
      if (this.personId) {
        this.id = this.personId;
        this.formServiceEndpoint = API_ENDPOINT_KEYS.getPersonBankDetailResponseAndConfig;
      }
    });
  }

  public buttonClicked(event: any): void { }

  public formLoaded(event: any): void {
    const personBankDetailResponse = event as PersonBankDetailResponse;
    this.bankDetailCreateUpdateType = personBankDetailResponse.bankDetailCreateUpdateType;
  }

  public modelChanged(event: any): void { }

  public save(event: SaveFormEvent) {
    this.activeDialog = '';
    if (this.bankDetailCreateUpdateType === BankDetailCreateUpdateType.NoBankDetailsCreateUpdateAllowed) {
      this.activeDialog = POP_UP_CODES.bankDetail.noBankDetailsCreateUpdateAllowed;
      this.dialogService.showDialog(this.activeDialog);
      return;
    }
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      if (!this.baseForm.fields[0]?.formControl.valid) {
        this.baseForm.showValidationSummary(true);
        this.activeDialog = POP_UP_CODES.common.validationError;
        this.dialogService.showDialog(this.activeDialog);
        return
      }
    }
    else {
      this.saveFormEvent = event;
      switch (this.bankDetailCreateUpdateType) {
        case BankDetailCreateUpdateType.OutstandingAcceptedCreateVendorApplication:
          this.activeDialog = POP_UP_CODES.bankDetail.outstandingAcceptedCrateVendorApplication;
          break;
        case BankDetailCreateUpdateType.ManuallyCreatedVendor:
          this.activeDialog = POP_UP_CODES.bankDetail.manuallyCreatedVendor;
          break;
        case BankDetailCreateUpdateType.UpdateBankDetails:
          this.activeDialog = POP_UP_CODES.bankDetail.updateBankDetails;
          break;
      }
      if (this.activeDialog !== '') {
        this.dialogService.showConfirm(this.activeDialog).subscribe(data => {
          if (data === DialogResult.REJECTED) {
            this.navigateToPerson(true);
          }
          else {
            this.saveData();
          }
        });;
      }
    }
  }

  public cancel(event: any) {
    this.navigateToPerson();
  }

  public dialogButton_noBankDetailsCreateUpdateAllowed_Clicked(event: any): void {
    this.navigateToPerson(true);
  }

  private saveData() {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: this.saveFormEvent.model,
      expectedLastUpdateTime: this.saveFormEvent.lastUpdatedTime,
      isSubmit: this.saveFormEvent.isSubmit
    }
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.dataService.saveData(API_ENDPOINTS.person.savePersonBankDetail, saveDataRequest)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            this.navigateToPerson(true);
          }
        })
    )
  }

  private navigateToPerson(ignoreUnsavedChanges = false) {
    this.navigate(['/', ROUTE_CONSTANTS.person.prefixDetail, this.id], ignoreUnsavedChanges);
  }
}
